import { useContext, useEffect, useMemo } from 'react';
// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
import { AuthContext } from 'src/auth/context/superadmin';

// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
// components
import Logo from 'src/components/logo';
import Scrollbar from 'src/components/scrollbar';
import { usePathname } from 'src/routes/hooks';
import { NavSectionVertical } from 'src/components/nav-section';
//
import { Typography } from '@mui/material';
import { NAV } from '../config-layout';
import { useNavData } from './config-navigation';
import { NavToggleButton, NavUpgrade } from '../_common';

// ----------------------------------------------------------------------

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
};

export default function NavVertical({ openNav, onCloseNav }: Props) {
  const { user } = useMockedUser();
  const { rolesAndPermissions } = useContext(AuthContext) as any;

  const navData = useNavData();

  const allowedTitles = useMemo(
    () =>
      rolesAndPermissions === null
        ? []
        : rolesAndPermissions?.map((role: any) => role?.name?.trim().toLowerCase()),
    [rolesAndPermissions]
  );

  const pathname = usePathname();

  const lgUp = useResponsive('up', 'lg');

  const filteredNavData = useMemo(() => {
    if (!rolesAndPermissions) {
      return [];
    }

    return navData.map((section) => ({
      ...section,
      items: section.items.filter((item) => {
        const title = item.title.trim().toLowerCase();

        // Always include "report"
        if (title === 'report') {
          return true;
        }

        // Always include "Yearly Planner"
        if (title === 'yearly planner') {
          return true;
        }

        // Include "permission" only if allowedTitles has any permissions
        if (title === 'permission') {
          return allowedTitles.length > 0;
        }

        // Include items that are allowed based on roles
        return allowedTitles.includes(title);
      }),
    }));
  }, [navData, allowedTitles, rolesAndPermissions]);

  console.log('filteredNavDatafilteredNavDatafilteredNavData0', filteredNavData);

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  // if (!rolesAndPermissions) {
  //   return null; // Optionally render a loading state here
  // }

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {/* <Logo sx={{ mt: 3, ml: 4, mb: 1 }} /> */}

      <Box
        component="img"
        src="/assets/images/login/logo.png"
        sx={{ width: 400, height: 'auto', mt: 3, ml: 1, }}
      />
         

      <NavSectionVertical
        data={filteredNavData}
        config={{
          currentRole: user?.role || 'admin',
        }}
      />
          <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="center"
            >
              <Typography variant="caption" color="white" sx={{ mr: 1,marginX:1 ,fontSize:16}}>
                Powered by
              </Typography>
              <Box
                component="img"
                src="/assets/images/login/logo2.png"
                alt="Powered by Logo"
                sx={{ width: 70, height: 'auto', cursor: 'pointer' }}
              />
            </Box>

      <Box sx={{ flexGrow: 1 }} />

      {/* <NavUpgrade /> */}
    </Scrollbar>
  );

  return (
    // <Box
    //   component="nav"
    //   sx={{
    //     flexShrink: { lg: 0 },
    //     width: { lg: NAV.W_VERTICAL },
    //   }}
    // >
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_VERTICAL },
        backgroundColor: '#808080',
      }}
    >
      <NavToggleButton />

      {lgUp ? (
        <Stack
          sx={{
            height: 1,
            position: 'fixed',
            width: NAV.W_VERTICAL,
            borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          }}
        >
          {renderContent}
        </Stack>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV.W_VERTICAL,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
